import { render, staticRenderFns } from "./ClientStatusView.vue?vue&type=template&id=4a435859&"
import script from "./ClientStatusView.vue?vue&type=script&lang=js&"
export * from "./ClientStatusView.vue?vue&type=script&lang=js&"
import style0 from "./ClientStatusView.vue?vue&type=style&index=0&id=4a435859&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports